import { render } from "./typeTable.vue?vue&type=template&id=0b69cccf&scoped=true"
const script = {}

import "./typeTable.vue?vue&type=style&index=0&id=0b69cccf&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b69cccf"]])

export default __exports__